import React from "react";
import "./loader.css";

const DOTS = 8;
const RADIUS = 38;

// Chasing-dots spinner (replaces the old pink animation_300 GIF) drawn in the hotel's
// secondary color via currentColor, so it follows the webapptheme like the rest of the UI.
const ThemeLoader = ({ className = "" }) => (
  <svg
    viewBox="0 0 100 100"
    role="status"
    aria-label="Loading"
    className={`theme-loader text-secondary ${className}`}
  >
    {Array.from({ length: DOTS }, (_, i) => {
      const angle = (i / DOTS) * 2 * Math.PI;
      return (
        <circle
          key={i}
          cx={50 + RADIUS * Math.cos(angle)}
          cy={50 + RADIUS * Math.sin(angle)}
          r={3 + i * 0.9}
          fill="currentColor"
          opacity={(i + 1) / DOTS}
        />
      );
    })}
  </svg>
);

export default ThemeLoader;
